/*
  Aetrex captions for videos that play on the page (assets/video-captions.js)

  The pop-up player (assets/video-lightbox.js) has its own captions. This file covers
  every other <video> on the site: section videos, product videos, the videos in page
  content (e.g. /pages/videos), and videos that swap their source later.

  Where captions come from
    snippets/video-captions-data.liquid prints, for each caption entry made in Caption
    Studio whose "match" text appears in the page, an inline
      <script type="text/vtt" data-caption-match="…" data-caption-lang="en">WEBVTT…</script>
    A video gets those captions when its web address contains the match text
    (a Shopify file's id, "playback/<vimeo id>/", or a file name; several can be given,
    separated by "|"). A block with data-caption-from="avl-vtt-…" reuses the WebVTT the
    pop-up button already printed instead of repeating it.

  How they show
    As a text track made by this script (addTextTrack + VTTCue), shown by the browser's
    own caption renderer, on by default. Never a <track src>: on iPhone, Safari passes
    <track> files to the system player, which can't open them and then won't play the
    video. A script-made track has no file to open.

    Videos are picked up when they start loading (the 'loadstart' event, caught for the
    whole page), so videos added later or switched to another source are covered too.

  API     window.AetrexVideoCaptions.refresh()   re-read captions and re-check every video
*/
(function () {
  'use strict';

  if (window.AetrexVideoCaptions) return;

  var doc = document;
  var blocks = null;

  function vttTime(v) {
    var m = /^(?:(\d+):)?(\d{1,2}):(\d{2})[.,](\d{1,3})/.exec(String(v || '').trim());
    if (!m) return NaN;
    return (+(m[1] || 0)) * 3600 + (+m[2]) * 60 + (+m[3]) + (+(m[4] + '00').slice(0, 3)) / 1000;
  }

  function parseVtt(text) {
    var out = [];
    var parts = String(text || '').replace(/<\\\//g, '</').replace(/\r\n?/g, '\n').split(/\n{2,}/);
    for (var i = 0; i < parts.length; i++) {
      var lines = parts[i].split('\n');
      for (var j = 0; j < lines.length; j++) {
        if (lines[j].indexOf('-->') < 0) continue;
        var times = lines[j].split('-->');
        var s = vttTime(times[0]);
        var e = vttTime(times[1]);
        var t = lines.slice(j + 1).join('\n').replace(/<[^>]*>/g, '')
          .replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').trim();
        if (isFinite(s) && isFinite(e) && e > s && t) out.push({ s: s, e: e, t: t });
        break;
      }
    }
    out.sort(function (a, b) { return a.s - b.s; });
    return out;
  }

  // One block per caption entry. data-caption-match can hold several texts separated by "|"
  // (the same video under different addresses). data-caption-from names the id of a block
  // already on the page (the pop-up button's) so its WebVTT isn't printed twice.
  function readBlocks() {
    blocks = [];
    var list = doc.querySelectorAll('script[type="text/vtt"][data-caption-match]');
    for (var i = 0; i < list.length; i++) {
      var parts = String(list[i].getAttribute('data-caption-match') || '').split('|');
      var matches = [];
      for (var j = 0; j < parts.length; j++) {
        var m = parts[j].trim();
        if (m.length >= 6) matches.push(m);
      }
      if (!matches.length) continue;
      blocks.push({
        id: matches.join('|'),
        matches: matches,
        lang: list[i].getAttribute('data-caption-lang') || 'en',
        el: list[i],
        cues: null
      });
    }
  }

  function vttOf(block) {
    var from = block.el.getAttribute('data-caption-from');
    var el = from ? doc.getElementById(from) : block.el;
    return el ? el.textContent : '';
  }

  function addresses(video) {
    var out = [];
    function add(u) {
      if (!u) return;
      out.push(u);
      try { out.push(decodeURIComponent(u)); } catch (e) { /* keep the raw one */ }
    }
    add(video.currentSrc);
    add(video.getAttribute('src'));
    var sources = video.querySelectorAll('source');
    for (var i = 0; i < sources.length; i++) add(sources[i].getAttribute('src'));
    return out;
  }

  function blockFor(video) {
    var urls = addresses(video);
    if (!urls.length) return null;
    for (var i = 0; i < blocks.length; i++) {
      for (var k = 0; k < blocks[i].matches.length; k++) {
        for (var j = 0; j < urls.length; j++) {
          if (urls[j].indexOf(blocks[i].matches[k]) >= 0) return blocks[i];
        }
      }
    }
    return null;
  }

  function clearCues(track) {
    while (track.cues && track.cues.length) track.removeCue(track.cues[0]);
  }

  function apply(video) {
    if (!video || video.tagName !== 'VIDEO') return;
    if (video.closest && video.closest('.avl')) return;           // the pop-up player does its own
    if (video.hasAttribute('data-no-captions')) return;
    if (video.querySelector('track')) return;                      // captions supplied some other way
    if (!blocks) readBlocks();
    var state = video.aetrexCaptions;
    var block = blocks.length ? blockFor(video) : null;
    try {
      if (!block) {
        if (state && state.match) {
          state.track.mode = 'hidden';
          clearCues(state.track);
          state.track.mode = 'disabled';
          state.match = null;
        }
        return;
      }
      if (state && state.match === block.id) return;
      if (typeof video.addTextTrack !== 'function' || typeof window.VTTCue !== 'function') return;
      if (!block.cues) block.cues = parseVtt(vttOf(block));
      if (!block.cues.length) return;
      if (!state) {
        state = video.aetrexCaptions = {
          track: video.addTextTrack('captions', block.lang === 'en' ? 'English' : block.lang, block.lang),
          match: null
        };
      }
      state.track.mode = 'hidden';
      clearCues(state.track);
      for (var i = 0; i < block.cues.length; i++) {
        state.track.addCue(new window.VTTCue(block.cues[i].s, block.cues[i].e, block.cues[i].t));
      }
      state.match = block.id;
      state.track.mode = 'showing';
    } catch (e) {
      if (window.console && console.warn) console.warn('[video-captions]', e);
    }
  }

  function applyAll() {
    var videos = doc.getElementsByTagName('video');
    for (var i = 0; i < videos.length; i++) apply(videos[i]);
  }

  // Media events don't bubble, but a capturing listener on the document still hears them.
  function onMedia(e) { apply(e.target); }
  doc.addEventListener('loadstart', onMedia, true);
  doc.addEventListener('loadedmetadata', onMedia, true);

  // Readable captions over any video, in the site's look.
  var style = doc.createElement('style');
  style.textContent = 'video::cue{background:rgba(8,8,10,.8);color:#fff;font-family:inherit;line-height:1.35}';
  (doc.head || doc.documentElement).appendChild(style);

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', applyAll);
  else applyAll();

  window.AetrexVideoCaptions = {
    refresh: function () { blocks = null; applyAll(); }
  };
})();
